import { format, toDate } from "date-fns";

//#region src/dateUtils.ts
function parseDate(date) {
	if (!date) return new Date();
	if (typeof date === "string") return toDate(Date.parse(date));
	return date;
}
function formatDate(value, opts = {}) {
	const { format: format$1 = "dd MMM yyyy", defaultValue = "" } = opts;
	if (!value) return defaultValue;
	return format(parseDate(value), format$1);
}

//#endregion
export { formatDate, parseDate };